import { PropsWithChildren } from "react";
import { Paper, Typography } from "@mui/material";

export function DashboardTile({ children }: PropsWithChildren) {
  return (
    <Paper
      sx={{
        p: 2,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </Paper>
  );
}

type DashboardTileTitleProps = PropsWithChildren & {
  strike?: boolean;
};

export function DashboardTileTitle({
  children,
  strike,
}: DashboardTileTitleProps) {
  return (
    <Typography
      component="h2"
      variant="h6"
      color={strike ? "GrayText" : "primary"}
      gutterBottom
      style={{ textDecoration: strike ? "line-through" : "inherit" }}
    >
      {children}
    </Typography>
  );
}